import axiosInstance from 'Api';

const organisationList = ()=>{
    return axiosInstance.get('organisation-link');
}

const saveOrganisationLink = (formData) => {
    return axiosInstance.post('organisation-link/save', formData);
};

const updateOrganisationLink = (formData)=>{
    return axiosInstance.post('organisation-link/update', formData);
}

const communityIdList = ()=>{
    return axiosInstance.get('organisation-link/community-list');
}

const deleteOrganisationLink = (id)=>{
    return axiosInstance.get(`organisation-link/delete/${id}`);
}

const AdminService = {
    organisationList,
    saveOrganisationLink,
    updateOrganisationLink,
    communityIdList,
    deleteOrganisationLink
};
export default AdminService;